import makeStateFilter from '../../make-state-filter';

import { stateFilter as parentStateFilter } from '../reducer.metadata';

export const namespace = 'sellerRecommendations';
export const stateFilter = makeStateFilter(parentStateFilter, namespace);
